var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8 3.3C5.8 2.975 6.05 2.7 6.4 2.7C6.725 2.7 7 2.975 7 3.3V6.4L9.125 7.8C9.4 8 9.475 8.375 9.275 8.65C9.1 8.925 8.725 9 8.45 8.8L6.05 7.2C5.9 7.1 5.8 6.9 5.8 6.7V3.3ZM6.4 0.3C9.925 0.3 12.8 3.175 12.8 6.7C12.8 10.25 9.925 13.1 6.4 13.1C2.85 13.1 0 10.25 0 6.7C0 3.175 2.85 0.3 6.4 0.3ZM1.2 6.7C1.2 9.575 3.525 11.9 6.4 11.9C9.25 11.9 11.6 9.575 11.6 6.7C11.6 3.85 9.25 1.5 6.4 1.5C3.525 1.5 1.2 3.85 1.2 6.7Z",
    fill: "#525B75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.d141a882729b2fa4c41bdebe1d3ee2f1.svg";
export { ForwardRef as ReactComponent };